// extracted by mini-css-extract-plugin
module.exports = {"switcherContainer":"AppSwitcher_switcherContainer__LaROQ","boldBtnTitle":"AppSwitcher_boldBtnTitle__5vAPu"};